import { View, Text, Image, TextInput, TouchableOpacity } from 'react-native'
import React, { useRef, useState, useEffect } from 'react'
import styles from '../../../components/customUtils/Components/EmailWidgetStyles'
import { getLanguage } from '../../appBar/context/LocalizationContext'
import theme from '../../../../theme'
import { fetchAuthSession, getCurrentUser, updateUserAttributes, sendUserAttributeVerificationCode, updateUserAttribute } from 'aws-amplify/auth'
import { verifyEmailCode, verifyPhoneNumberCode } from '../../../utils/cognitoUtils'
import { request_edit_user_profile } from '../../../services/user.services'
// import { getAuthToken } from '@/utils/functions.utils'
import { getAuthToken } from '../../../utils/functions.utils'
import { useIsMobile } from '@/redux/zustand/useDimensionStore'

const EmailWidget = ({ type, formData, user_data, closeBottomSheet, fieldsMap, setUpdated, fetchData }) => {
    const { languageFile } = getLanguage()
    const [verificationCode, setVerificationCode] = useState('')
    const [timer, setTimer] = useState(60) // Temporizador de 60 segundos
    const [isResendEnabled, setIsResendEnabled] = useState(false) // Estado para habilitar el botón de reenviar

    useEffect(() => {
        if (timer > 0) {
            const countdown = setTimeout(() => setTimer(timer - 1), 1000)
            return () => clearTimeout(countdown)
        } else {
            setIsResendEnabled(true) // Habilita el botón cuando el tiempo llega a 0
        }
    }, [timer])

    const handleResendCode = async () => {
        let phone = formData['Teléfono'].startsWith('+549') ? formData['Teléfono'] : `+549${formData['Teléfono']}`
        setIsResendEnabled(false)
        setTimer(60) // Restablecer el temporizador a 60 segundos
        const user = await getCurrentUser()

        try {
            if (type === 'phone') {
                const updateRes = await updateUserAttribute({
                    userAttribute: {
                        attributeKey: 'phone_number',
                        value: phone,
                    },
                })
                console.log('📲 updateUserAttribute phone_number:', updateRes)

                const codeNoSend =
                    updateRes && updateRes.nextStep && updateRes.nextStep.updateAttributeStep && updateRes.nextStep.updateAttributeStep === 'DONE'

                if (codeNoSend) {
                    console.log('El código de verificación phone ya fue enviado previamente. Uso sendUserAttributeVerificationCode')
                    const responseSend = await sendUserAttributeVerificationCode({
                        userAttributeKey: 'phone_number',
                    })
                    console.log('📲 sendUserAttributeVerificationCode phone_number:', responseSend)
                }
            } else if (type === 'email') {
                console.log('Reenviando código de verificación de email a:', formData['Email'])

                const updateRes = await updateUserAttribute({
                    userAttribute: {
                        attributeKey: 'email',
                        value: formData['Email'],
                    },
                })

                console.log('📲 updateUserAttribute email:', updateRes)

                const codeNoSend =
                    updateRes && updateRes.nextStep && updateRes.nextStep.updateAttributeStep && updateRes.nextStep.updateAttributeStep === 'DONE'

                if (codeNoSend) {
                    console.log('El código de verificación email ya fue enviado previamente. Uso sendUserAttributeVerificationCode')
                    const responseSend = await sendUserAttributeVerificationCode({
                        userAttributeKey: 'email',
                    })
                    console.log('📲 sendUserAttributeVerificationCode email:', responseSend)
                }
            }
        } catch (error) {
            console.error('Error reenviando el código:', error)
        }
    }

    const handleModalVerificationPhone = async (verificationCode) => {
        try {
            console.log('🚀 ~ handleModalVerificationPhone ~ verificationCode:', verificationCode)
            const authToken = await getAuthToken()
            let verifyCode = await verifyPhoneNumberCode(verificationCode)
            console.log('🚀 ~ handleModalVerificationPhone ~ verifyCode:', verifyCode)
            let editedData = {}

            for (const key in formData) {
                if (formData.hasOwnProperty(key)) {
                    editedData[fieldsMap[key]] = formData[key]
                }
                // if (formData.hasOwnProperty(key) && formData[key] !== user_data[fieldsMap[key]]) {
                //     editedData[fieldsMap[key]] = formData[key]
                // }
            }
            if (verifyCode['success']) {
                let update_profile = await request_edit_user_profile(authToken, editedData, undefined)
                console.log('1fetchData => ', fetchData)
                console.log('1typeof fetchData => ', typeof fetchData)

                if (fetchData != null && typeof fetchData === 'function') {
                    await fetchData()
                }
                closeBottomSheet(true)
                // setUpdated(true)
            }
        } catch (error) {
            console.error('Error en la verificación del teléfono:', error)
        }
    }

    const handleModalVerification = async (verificationCode) => {
        try {
            console.log('🚀 ~ handleModalVerification ~ verificationCode:', verificationCode)
            // const database = await openDB()
            // const authToken = session.tokens?.accessToken?.toString()
            const authToken = await getAuthToken()

            let verifyCode = await verifyEmailCode(verificationCode)
            console.log('🚀 ~ handleModalVerification ~ verifyCode:', verifyCode)

            let editedData = {}

            for (const key in formData) {
                if (formData.hasOwnProperty(key)) {
                    editedData[fieldsMap[key]] = formData[key]
                }
                // if (formData.hasOwnProperty(key) !== user_data[fieldsMap[key]]) {
                //     editedData[fieldsMap[key]] = formData[key]
                // }
            }
            if (verifyCode['success']) {
                // setShowModalVerification(false)

                let update_profile = await request_edit_user_profile(authToken, editedData, undefined)

                console.log('1fetchData => ', fetchData)
                console.log('1typeof fetchData => ', typeof fetchData)
                if (fetchData != null && typeof fetchData === 'function') {
                    await fetchData()
                }
                closeBottomSheet(true)
                // setUpdated(true)
            }
        } catch (error) {
            console.error('Error en la verificación del email:', error)
        }
    }

    const handleVerification = () => {
        if (type === 'phone') {
            handleModalVerificationPhone(verificationCode)
        } else {
            handleModalVerification(verificationCode)
        }
    }
    const isMobile = useIsMobile()
    return (
        <View style={[styles.modalContainer, !isMobile && { maxWidth: 500 }]}>
            {type === 'email' && <Image style={styles.image} source={require('../../../../assets/editEmail.png')} resizeMode='contain' />}
            {type === 'phone' && <Image style={styles.image} source={require('../../../../assets/editPhone.png')} resizeMode='contain' />}
            {type === 'email' && <Text style={styles.modalTitle}>Validá tu email</Text>}
            {type === 'phone' && <Text style={styles.modalTitle}>Validá tu celular</Text>}
            {type === 'email' && <Text style={styles.modalSubtitle}>Recibirás un código en tu correo electrónico para ingresarlo.</Text>}
            {type === 'phone' && <Text style={styles.modalSubtitle}>Recibirás un código SMS para ingresarlo.</Text>}
            <Text style={styles.modalSubtitle}>Si aún no recibiste el código, vuelve a intentarlo.</Text>
            <Text style={styles.modalTitle}>Código de verificación</Text>
            <View style={{ flexDirection: 'row', marginVertical: 10, marginHorizontal: 20, width: '100%' }}>
                <VerificationCodeInput setVerificationCode={setVerificationCode} />
            </View>
            <Text style={styles.modalSubtitle}>{timer > 0 ? `Puedes reenviar el código en ${timer} segundos` : '¿No recibiste el código?'}</Text>
            <View style={styles.buttonContainer}>
                <TouchableOpacity style={{ paddingVertical: 10 }} onPress={() => handleResendCode()} disabled={!isResendEnabled}>
                    <Text style={[styles.mainButtonText, { color: isResendEnabled ? theme.colors.colorPrimary : theme.colors.darkGray }]}>
                        Reenviar código
                    </Text>
                </TouchableOpacity>

                <TouchableOpacity style={[styles.mainButton, { backgroundColor: theme.colors.colorPrimary }]} onPress={() => handleVerification()}>
                    <Text style={styles.mainButtonText}>{languageFile.confirm}</Text>
                </TouchableOpacity>
                <View style={styles.spacer1}></View>
                {/*<TouchableOpacity style={styles.borderButton} onPress={() => closeBottomSheet(true)}>
                    <Text style={styles.borderButtonText}>{languageFile.cancel}</Text>
                </TouchableOpacity>*/}
            </View>
            <View style={styles.spacer1}></View>
        </View>
    )
}
const VerificationCodeInput = ({ setVerificationCode }) => {
    const [code, setCode] = useState(new Array(6).fill('')) // Array de 6 dígitos vacíos
    const inputRefs = useRef([])

    // Maneja el cambio en cada TextInput
    const handleInputChange = (text, index) => {
        const newCode = [...code]
        newCode[index] = text
        setCode(newCode)

        // Si se ingresa un dígito, mueve el foco al siguiente input
        if (text && index < 5) {
            inputRefs.current[index + 1].focus()
        }

        // Si el código está completo (6 dígitos)
        if (newCode.join('').length === 6) {
            // console.log(newCode)
            setVerificationCode(newCode.join(''))
            // handleVerification(newCode.join(''));
        }
    }

    const handleKeyPress = (e, index) => {
        // Si se presiona la tecla de retroceso y el campo está vacío, mueve el foco al campo anterior
        if (e.nativeEvent.key === 'Backspace' && index > 0 && !code[index]) {
            inputRefs.current[index - 1].focus()
        }
    }
    const [viewWidth, setWidth] = useState(0)
    return (
        <View
            style={{ flexDirection: 'row', paddingHorizontal: 20, width: '100%' }}
            onLayout={(e) => {
                const lWidth = e?.nativeEvent?.layout?.width || 0
                setWidth(lWidth - 80) //Se resta el padding pq lWidth lo incluye en su valor
            }}
        >
            {/* <Text style={{ position: 'absolute' }}>{viewWidth}</Text> */}
            {viewWidth > 0 &&
                code.map((digit, index) => (
                    <TextInput
                        key={index}
                        style={[styles.inputCode, styles.inputCodeText, { width: viewWidth / code.length }]}
                        keyboardType='numeric'
                        maxLength={1}
                        value={digit}
                        onChangeText={(text) => handleInputChange(text, index)}
                        onKeyPress={(e) => handleKeyPress(e, index)}
                        ref={(ref) => (inputRefs.current[index] = ref)} // Asigna referencia para el manejo de foco
                    />
                ))}
        </View>
    )
}

export default EmailWidget
